<template>
        <v-tabs class="support-ticket-v2" color="#FA1E95" grow v-model="tab" @change="refreshTable()">
            <v-tab v-for="(item, i) in tabs" :key="i">
                {{ item }}
            </v-tab>
            <v-tab-item>
                <div class="pt-5">
                    <validation-observer ref="refComponent" tag="form">
                            <v-row>
                                <v-col cols="12" class="pt-0 pb-0">
                                <validation-provider v-slot="{ errors }"  name="Nhóm ticket" rules="required">
                                    <v-autocomplete
                                        v-model="groupTicketName"
                                        :items="listTicketGroup"
                                        item-text="groupTicketName"
                                        item-value="groupTicketName"
                                        label="Chọn nhóm ticket"
                                        class="ma-0 pa-0"
                                        :error-messages="errors"
                                        attach
                                        clearable
                                        :aLight="'right'"
                                        @change="changeTicketGroup"
                                    >

                                    </v-autocomplete>
                                </validation-provider>
                                </v-col>
                                <v-col cols="12" class="pt-0 pb-0" v-if="checkTicketType(groupTicketName) ">
                                <validation-provider v-slot="{ errors }"  name="Loại ticket" :rules="checkTicketType(groupTicketName)  ? 'required' : ''">
                                    <v-autocomplete
                                        v-model="typeTicketName"
                                        :items="listTicketType"
                                        item-text="typeTicketName"
                                        item-value="typeTicketName"
                                        attach
                                        :aLight="'right'"
                                        clearable
                                        class="ma-0 pa-0"
                                        label="Chọn loại ticket"
                                        :error-messages="errors"
                                        @change="changeTicketType"
                                    />
                                </validation-provider>
                                </v-col>
                                <template v-for="(component, index) in templateFields">
                                    <v-col :cols="component.col ? component.col : 12" class="pt-0 pb-0" :key="index">
                                        <base-text
                                                v-if="component.dataType === typeComponent.text && component.isShow == 1"
                                                v-model="dataComponent[component.name]"
                                                :rule-form-ref="$refs.refComponent"
                                                :label="component.label"
                                                :name-ref="component.name"
                                                :event-model="component.event"
                                                :required="component.required || checkRequired(component.name)"
                                                :clearable="!component.readonly"
                                                :readonly="component.readonly"
                                                @searchInput="searchInput"
                                        />
                                        <base-number
                                          v-if="component.dataType === typeComponent.number && component.isShow == 1"
                                          v-model="dataComponent[component.name]"
                                          :rule-form-ref="$refs.refComponent"
                                          :label="component.label"
                                          :name-ref="component.name"
                                          :event-model="component.event"
                                          :required="component.required || checkRequired(component.name)"
                                          :clearable="!component.readonly"
                                          :readonly="component.readonly"
                                          @searchInput="searchInput"
                                        />
                                        <base-select
                                                v-if="component.dataType === typeComponent.select && component.isShow == 1"
                                                :label="component.label"
                                                :name-ref="component.name"
                                                :rule-form-ref="$refs.refComponent"
                                                v-model="dataComponent[component.name]"
                                                :value="dataComponent[component.name]"
                                                :options="component.dataMapField"
                                                :required="component.required"
                                                :event-model="component.event"
                                                :clearable="!component.readonly"
                                                :readonly="component.readonly"
                                                @onChangeData="searchInput"
                                        />
                                        <template    v-if="component.dataType === typeComponent.file && component.isShow == 1">
                                            <div class="d-flex align-center" style="column-gap: 10px;"   v-for="(file, indexFile) in dataComponent[component.name]">
                                                <div style="width: calc(100% - 50px)">
                                                    <base-file
                                                      :key="indexFile+'file'"
                                                      :label="component.label"
                                                      :name-ref="component.name"
                                                      :rule-form-ref="$refs.refComponent"
                                                      v-model="file.name"
                                                      :value="file.name"
                                                      :required="component.required"
                                                      :event-model="component.event"
                                                    />
                                                </div>
                                                <div style="width: 40px; justify-content: center" class="d-flex align-center">
                                                    <v-btn @click="handleDeleteFile(file)"
                                                           color="primary"
                                                           small
                                                           icon
                                                           style="background: white !important;">
                                                        <v-icon>mdi-delete-outline</v-icon>
                                                    </v-btn>
                                                </div>
                                            </div>
                                            <v-btn @click="handleAddFile()"
                                                   text
                                                   small
                                                   style="background: white !important; color: blue !important"
                                                   v-if="dataComponent[component.name].length < 5"
                                            > <v-icon>mdi-plus</v-icon> Thêm file
                                            </v-btn>
                                        </template>
                                        <base-textarea
                                          v-if="component.dataType === typeComponent.textarea && component.isShow == 1"
                                          v-model="dataComponent[component.name]"
                                          :rule-form-ref="$refs.refComponent"
                                          :label="component.label"
                                          :name-ref="component.name"
                                          :event-model="component.event"
                                          :required="component.required"
                                          :clearable="!component.readonly"
                                          :readonly="component.readonly"
                                          @searchInput="searchInput"
                                        />
                                    </v-col>
                                </template>
                                <v-col cols="12" class="pt-3 pb-3">
                                    <div class="d-flex align-center justify-center">
                                    <v-btn class="primary mx-2" @click="handleCreate()">Gửi hỗ trợ</v-btn>
                                </div>
                                </v-col>
                            </v-row>
                <!--            {{ dataComponent }}-->
                    </validation-observer>
                    <v-dialog v-if="dialogConfirmSupport" content-class="dialog-waiting" class="text-center p-3" v-model="dialogConfirmSupport" width="440">
                        <template>
                            <div style="background-color: #fff; padding: 20px; min-height: 200px;">
                                <svg
                                    class="float-left ml-2" width="68" height="68" viewBox="0 0 68 68" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M37.4 23.8H30.6V17H37.4M37.4 51H30.6V30.6H37.4M34 0C29.5351 0 25.1138 0.879436 20.9888 2.5881C16.8637 4.29676 13.1156 6.80118 9.95837 9.95837C3.58213 16.3346 0 24.9826 0 34C0 43.0174 3.58213 51.6654 9.95837 58.0416C13.1156 61.1988 16.8637 63.7033 20.9888 65.4119C25.1138 67.1206 29.5351 68 34 68C43.0174 68 51.6654 64.4179 58.0416 58.0416C64.4179 51.6654 68 43.0174 68 34C68 29.5351 67.1206 25.1138 65.4119 20.9888C63.7033 16.8637 61.1988 13.1156 58.0416 9.95837C54.8844 6.80118 51.1363 4.29676 47.0112 2.5881C42.8862 0.879436 38.4649 0 34 0Z"
                                        fill="#0088FF"/>
                                </svg>
                                <div style="width: calc(100% - 110px) !important;    max-width: none !important;" class="text-2 float-right ml-2">
                                    <p>Mã khách hàng: {{ dataComponent.customerCode }}</p>
                                    <p  v-if="groupTicketName" class="ma-0">Nhóm: {{ groupTicketName }}</p>
                                    <p v-if="typeTicketName" class="">Loại: {{ typeTicketName}}</p>
                                    <p>Nhấn xác nhận thông tin để tạo hỗ trợ.</p>
                                    <div class="group-btn">
                                        <v-btn color="#0088ff" class="ma-0 mr-2" @click="createForm"
                                        >Xác nhận</v-btn
                                        >
                                        <v-btn
                                            color="btn-cancel"
                                            class="ma-0 mr-2"
                                            @click="dialogConfirmSupport = false"
                                        >Hủy</v-btn>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-dialog>
                </div>
            </v-tab-item>
            <v-tab-item>
                <filter-form :listTicketGroup="listTicketGroup" :listTicketStatus="listTicketStatus"/>
                <support-table :listTicketStatus="listTicketStatus"/>
            </v-tab-item>
        </v-tabs>

</template>
<script>
import BaseText from "@/pages/teacher-support/components/base-text.vue";
import BaseSelect from "@/pages/teacher-support/components/base-select.vue";
import BaseFile from "@/pages/teacher-support/components/base-file.vue";
import RepositoryFactory from "@/repositories/RepositoryFactory";
import Repository from "@/repositories/Repository";
import TokenService from "@/helpers/token";
import SupportTable from './SupportTable'
import FilterForm from './FilterForm'
import BaseTextarea from "@/pages/teacher-support/components/base-textarea.vue";
import BaseNumber from "@/pages/teacher-support/components/base-number.vue";
const TicketRepository = RepositoryFactory.get("ticket");
import {v1 as uuidv1} from 'uuid'
const dataConstForm = {
    customerCode: "",
    studentName: "",
    studentId: "",
    homeRoomTeacherName: "",
    classCode: "",
    teacherName: "",
    teacherCode: "",
    careTakerName: "",
    description: "",
    fileAttachment: [
        { id: uuidv1(), name: '' }
    ],
    recipientName:'',
    receiverAddress:'',
    otherAddress:'',
    nameCodeLeader:'',
    departmentOfTheTicketCreator:'',
    phoneNumber: '',
    orderType: '',
    orderCode1: '',
    orderCode2: '',
    orderCode3: '',
    paymentMethod: '',
    gradeLevel: '',
}
export default {
    name: 'MasterForm',
    components: {BaseNumber, BaseTextarea, BaseFile, BaseSelect, BaseText, SupportTable, FilterForm},
    data() {
        return {
            tabs: ["Gửi hỗ trợ", "Danh sách"],
            tab: 0,
            typeComponent: {
                text: 'text',
                select: 'select',
                textarea: 'textarea',
                file: 'file',
                number: 'number',
            },
            dataComponent: { ...dataConstForm },
            groupTicketName: '',
            typeTicketName: '',
            listTicketGroup: [],
            templateFields: [],
            moduleId: '',
            templateId: '',
            dialogConfirmSupport: false,
            listTicketStatus: [],
            listTicketGroupClone: [],
        }
    },
    created() {
        this.getListTicketStatus();
        if(this.$route.query?.tab == 1 ){
            this.tab = 1
        }
        this.getTicketSystemModule()
    },
    computed: {
        listTicketType() {
            if (this.listTicketGroup.length) {
                return this.listTicketGroup.filter((item) => (item.typeTicketName != '' || item.typeTicketName != null) && item.groupTicketName === this.groupTicketName);
            }
            return [];
        }
    },
    methods: {
      checkRequired(componentName) {
        const listNoRequired = [
          "orderCode2",
          "orderCode3",
          "phoneNumber",
          "otherAddress"
        ]
        if(componentName) {
         return !listNoRequired.includes(componentName)
        }
        return true
      },
        handleDeleteFile(file) {
            const index =  this.dataComponent.fileAttachment.findIndex(item => item.id === file.id)
            this.dataComponent.fileAttachment.splice(index, 1);
        },
        handleAddFile() {
          this.dataComponent.fileAttachment.push({ id:uuidv1(), name: '' })
        },
        async getListTicketStatus() {
          const result = await TicketRepository.getListTicketStatus();
          if (result.success) {
            this.listTicketStatus = result.data
          }
        },
        refreshTable() {
            this.$router.push({ query: { tab: this.tab } })
            if (this.tab == 1 ){
                Bus.$emit('refresh-ticket-v2')
            } else if (this.tab == 0) {
                this.typeTicketName =  ''
                this.templateFields =  ''
                this.groupTicketName =  ''
                this.templateFields =  []
                this.dataComponent = _.cloneDeep(dataConstForm)
                this.$refs.refComponent.reset();
            }
        },
        checkTicketType(ticketGroup) {
            const filterData = this.listTicketGroup.filter((item) => item.groupTicketName === ticketGroup);
            if (filterData.length > 0 && filterData[0].typeTicketName != null) {
                return true;
            }
            return false;
        },
        changeTicketGroup(value) {
            this.typeTicketName = '';
            this.templateId = '';
            this.templateFields = [];
            this.dataComponent = _.cloneDeep(dataConstForm);
            this.listTicketGroup = _.cloneDeep(this.listTicketGroupClone);
            if(value) {
                const filterData = this.listTicketGroup.filter(item => item.groupTicketName == value)
                if (filterData.length === 1 && filterData[0].typeTicketName == null) {
                    this.templateFields = filterData[0].templateFields
                    this.templateId = filterData[0].id
                    this.checkTicketType();
                    this.checkDataType();
                }
            }
        },
        changeTicketType(value) {
            this.templateId = '';
            this.templateFields = [];
            this.dataComponent = _.cloneDeep(dataConstForm);
            this.listTicketGroup = _.cloneDeep(this.listTicketGroupClone);
            if (value) {
                if (this.groupTicketName) {
                    const filterData = this.listTicketGroup.filter((item) => item.groupTicketName === this.groupTicketName && item.typeTicketName === value);
                    if (filterData.length) {
                        this.templateFields = filterData[0].templateFields;
                        this.templateId = filterData[0].id;
                        this.checkTicketType();
                        this.checkDataType();
                    }
                }
            }
        },
        async checkDataType() {
            const dataClone = _.cloneDeep(this.dataComponent);
            const loader = this.$loading.show();
            // eslint-disable-next-line guard-for-in,no-restricted-syntax
            const listQuery = _.cloneDeep(this.$route.query)
            delete listQuery.tab
            for (const item of this.templateFields) {
                // eslint-disable-next-line no-restricted-syntax
                for (const key in listQuery) {
                    dataClone[key] = listQuery[key];
                    if (item.name === key) {
                        if (item.linkApi !== null) {
                            // eslint-disable-next-line no-await-in-loop
                            await this.updateDataMapField(item, dataClone, false);
                        }
                        // item.readonly = true;
                        this.dataComponent[item.name] = (key === 'studentId' || key === 'classCode' || key === 'phoneNumber') && listQuery[key] ? Number(listQuery[key]) : listQuery[key];
                        const dataField = {
                            data: this.dataComponent[item.name],
                            name: item.name,
                            event: item.event,
                        };
                        // if (item.event.length) {
                        // eslint-disable-next-line no-await-in-loop
                        await this.searchInput(dataField);
                        // }
                    }
                }
                if((item.isShow === 1 || item.sendToBizfly === 1) &&
                    (['nameCodeLeader','departmentOfTheTicketCreator', 'orderType', 'paymentMethod', 'gradeLevel'].includes(item.name))) {
                    if (item.linkApi !== null) {
                        // eslint-disable-next-line no-await-in-loop
                        await this.updateDataMapField(item, dataClone, false);
                    }
                }
            }
            loader.hide();
        },
        async getTicketSystemModule() {
            const params = {
                typeId: this.$store.state.module.typeId,
                schoolLevelId: this.$store.state.module.schoolLevelId,
            }
            try{
                const response = await TicketRepository.getTicketSystemModuleApi(params)
                if(response.success) {
                    this.moduleId = response.data ? response.data.moduleId : '';
                    if(this.moduleId) {
                     await this.getListTicketGroup()
                    }
                }
            }catch (e) {
                console.log(e)
            }
        },
        async getListTicketGroup() {
            const currentPath = this.$router.currentRoute.path;
            const trimmedPath = currentPath.replace(/^\/+/, '');
            const params = {
                'filters[$eq__screen]': trimmedPath,
                'filters[$eq__systemId]': 1,
                'filters[$eq__moduleId]': this.moduleId,
                limit: 9999,
            }
            const response = await TicketRepository.getListTicketApi(params)
            if(response.success) {
                this.listTicketGroup = response.data;
                this.listTicketGroupClone = response.data;
            }
        },
        async searchInput(component) {
            if (component.event.length === 0) {
                return;
            }
            const dataFilter = this.templateFields.filter((item) => component.event.includes(item.id));
            if (component.data) {
                const loader = this.$loading.show();
                const body = {};
                if (dataFilter.length > 0) {
                    body[component.name] = component.data;
                    if(component.data !== this.dataComponent[component.name]) {
                        for (const item of dataFilter) {
                            this.clearItem(item);
                        }
                    }
                    const params = { ...this.dataComponent, ...body };
                    // eslint-disable-next-line no-restricted-syntax
                    for (const item of dataFilter) {
                        // if (!this.dataComponent[item.name]) {
                            // eslint-disable-next-line no-await-in-loop
                            await this.processItem(item, params, component.change);
                        // }
                    }
                    // loader.hide();
                }
                // }
                loader.hide();
            } else if (dataFilter.length > 0) {
                // eslint-disable-next-line no-restricted-syntax
                for (const item of dataFilter) {
                    this.clearItem(item);
                }
            }
            console.log(this.dataComponent, 375)
        },
        clearItem(item) {
            this.dataComponent[item.name] = ''
            item.dataMapField = []
            const dataFind = this.templateFields.filter(dataField => item.event.includes(dataField.id))
            if (dataFind.length > 0) {
                for (const innerItem of dataFind) {
                    this.clearItem(innerItem)
                }
            }
        },
        async processItem(item, params, isChange = false) {
            if ((this.dataComponent[item.name] === '' && item.dataMapField.length === 0) || isChange) {
                const dataUpdate = await this.updateDataMapField(item, params, isChange);
                if (dataUpdate && dataUpdate.dataMapField && dataUpdate.dataMapField.length === 1) {
                    this.dataComponent[dataUpdate.name] = dataUpdate.dataMapField[0].name;
                    const dataFind = this.templateFields.filter((dataField) => dataUpdate.event.includes(dataField.id));
                    if (dataFind.length > 0) {
                        const innerBody = {};
                        innerBody[dataUpdate.name] = this.dataComponent[dataUpdate.name];
                        // eslint-disable-next-line no-shadow
                        const params = { ...this.dataComponent, ...innerBody };
                        // eslint-disable-next-line no-restricted-syntax
                        for (const innerItem of dataFind) {
                            // eslint-disable-next-line no-await-in-loop
                            await this.processItem(innerItem, params);
                        }
                    }
                }
            }
        },
        async updateDataMapField(item, body, isChange) {
            if ((item.linkApi !== null && this.dataComponent[item.name] === '') || isChange) {
                try {
                    const response = await Repository.post(`${item.linkApi}`, body, { headers: TokenService.getHeader() });
                    if (response.success) {
                        // eslint-disable-next-line no-param-reassign
                        item.dataMapField = response.data ? response.data : [];
                    } else {
                        // eslint-disable-next-line no-param-reassign
                        item.dataMapField = [];
                    }
                    if (item.dataMapField.length === 0) {
                        this.dataComponent[item.name] = '';
                    }
                    return item;
                } catch (error) {
                    console.log(error);
                }
            }
        },
        async handleCreate(){
            const valid =await this.$refs.refComponent.validate()
            if(valid) {
                this.dialogConfirmSupport = true
            }
        },
        async createForm() {
            const params = {
                templateId: this.templateId,
                ...this.dataComponent
            }
            if(params.fileAttachment.length > 0) {
                let dataFilter = []
                params.fileAttachment.forEach(item => {
                    if(item.name !== '') {
                        dataFilter.push(item.name)
                    }
                })
                params.fileAttachment = dataFilter
            }
            try {
                const loading = this.$loading.show()
                const response = await TicketRepository.createTicketApi(params)
                loading.hide()
                if(response.success) {
                    this.dialogConfirmSupport = false
                    this.$swal({
                        type: "success",
                        icon: "success",
                        text: "Gửi hỗ trợ khách hàng thành công",
                    }).then(() => {
                      this.tab = 1
                      Bus.$emit('refresh-ticket-v2')
                    });
                }else {
                    this.$swal({
                        type: "error",
                        icon: "error",
                        html: `<b>Có lỗi hệ thống<br><br> ${ response.message }.</b>`,
                    });
                }
            }catch (e) {
                console.log(e)
            }
        }
    }
}
</script>

<style lang="scss">
    .support-ticket-v2 {
        .v-card {
            box-shadow: none;
            -web-kit-box-shadow: none;
            background-color: #fff;
        }
    }
</style>